import * as React from "react";
import { UserRole } from "@models/user-role";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import { Divider, Modal, Table, Button } from "antd";
import Message from "@constants/message";
import UserRoleForm from "@components/user-roles/Form";
import { PaginationDefaultParams } from "../custom/Paginator";
import { NavLink } from "react-router-dom";

type Props = {
  data: UserRole[];
  loading: boolean;
  deleteFn: (item: UserRole) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const UserRolesTable: React.FC<Props> = props => {
  const { data, loading, currentPage, deleteFn, intl } = props;
  const { formatMessage } = intl;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;

  const deleteTag = (item: UserRole): void => {
    Modal.confirm({
      content: formatMessage({
        id: "app.general_delete_warning",
        defaultMessage: Message.Warning.Delete
      }),
      okText: formatMessage({
        id: "app.delete",
        defaultMessage: "Delete"
      }),
      cancelText: formatMessage({
        id: "app.cancel",
        defaultMessage: "Cancel"
      }),
      className: "delete-confirm-dialog",
      onOk: () => deleteFn(item)
    });
  };

  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`} />,
      width: 30,
      align:"right",
      dataIndex: "index",
      key: "id",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: <FormattedMessage id="app.title" defaultMessage={`Title`} />,
      width: 150,
      align:"right",
      dataIndex: "title",
      key: "title"
    },
    {
      title: "",
      key: "actions",
      width: 90,
      dataIndex: "actions",
      render: (text, record) => (
        <span>
          <NavLink to={`/users/roles/${record.id}/edit`}>
            <Button type="link" size={`small`}>
              <FormattedMessage id="app.edit" defaultMessage={`Edit`} />
            </Button>
          </NavLink>

          <Divider type="vertical" size={`small`} />

          <Button
            type="link"
            className={`danger`}
            onClick={() => deleteTag(record)}
          >
            <FormattedMessage id="app.delete" defaultMessage={`Delete`} />
          </Button>
        </span>
      )
    }
  ];

  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default injectIntl(UserRolesTable);
